@if (reRender) {
  <ng-container *appTranslate="let t; lang: viewLanguage + '|static'">
    <div class="dialog-form h-full">
      <div class="flex-auto min-h-0">
        <new-ui-tc-consent-view
          [consents]="consents"
          [viewLanguage]="viewLanguage"
          [initalIndex]="lastIndex"
          [dialogMode]="true"
          (tabChanged)="onTabChanged($event)"
        />
      </div>

      <new-ui-checkbox [label]="t('consent.read')" [formControl]="agreedControl" />

      <new-ui-button
        [fluid]="true"
        icon="icon-[mi--checkmark-medium]"
        [label]="t('common.ok')"
        (onClick)="okClicked()"
        [disabled]="!agreedControl.value"
      />
    </div>
  </ng-container>
}
